export default class Zoom {

    constructor() {

        this.init();

    }

    init() {

        // 画像を拡大・縮小できるモーダルのイベントを追加
        this.addZoomImg();

    }

    addZoomImg() {

        const $openArray = [...document.querySelectorAll('.c-zoom__open')],
            $modal = document.querySelector('.c-zoom__modal'),
            $inner = $modal.querySelector('div'),
            $close = $modal.querySelector('button');

        $openArray.forEach($open => {
            $open.addEventListener('click', () => {
                const $getImg = $open.querySelector('img'),
                    $setImg = document.createElement('img');
                $setImg.src = $getImg.src;
                $inner.appendChild($setImg);
                $modal.classList.add('-active');
            });
        });

        $close.addEventListener('click', () => {
            $modal.classList.remove('-active');
        });

        $modal.addEventListener('transitionend', e => {
            if (!e.currentTarget.classList.contains('-active')) {
                $inner.innerHTML = '';
            }
        });

    }

}